<div class="stats-card d-flex align-items-center" [class.small]="size === 'small'" [class.large]="size === 'large'"
  [ngbTooltip]="tooltip" placement="top" triggers="hover" container="body" [openDelay]="300" [closeDelay]="100">
  <!-- Trend indicator -->
  @if (trend) {
    <div class="trend-indicator" [class.trend-up]="trend === 'up'" [class.trend-down]="trend === 'down'">
      <i class="fa" [class.fa-arrow-trend-up]="trend === 'up'" [class.fa-arrow-trend-down]="trend === 'down'"></i>
      @if (trendPercentage !== null) {
        <span class="trend-percentage">{{ trend === 'up' ? '+' : '-' }}{{ trendPercentage }}%</span>
      }
    </div>
  }
  <div class="flex-grow-1 content-wrapper">
    <div [ngClass]="size === 'large' ? 'label-large' : 'label'">{{ label }}</div>
    <!-- If items array is provided display items else single value -->
    @if (items.length) {
      <div class="items d-flex align-items-center">
        @for (item of items; track item; let last = $last) {
          <div class="item text-center flex-grow-1 w-100">
            <div class="item-label">{{ item.label }}</div>
            <div class="item-value">{{ item.value }}</div>
          </div>
          @if (!last) {
            <div class="divider"></div>
          }
        }
      </div>
    } @else {
      <div class="value">{{ value }}</div>
    }
  </div>
</div>